<template>
  <button @click="change()" class="btn-current-status">
    <i class="fa" :class="status"></i>
  </button>
</template>
<script>
    export default {

        props:{
            energyCode:{
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                current: this.energyCode.is_current,
                form: new Form({
                    current: !this.energyCode.is_current
                }),
            }
        },

        methods:{
            change() {
                if (this.current) return;
                  this.form.post(`/energy-codes/${this.energyCode.year}/current`).then(response => {
                      this.form.current = !response.is_current
                      App.bus.$emit('current-energy-code', response);
                  })
            }
        },

        computed: {
            status() {
                return {
                    'fa-times text-danger': (!this.current && !this.form.isSubmitted),
                    'fa-check text-success': (this.current && !this.form.isSubmitted),
                    'fa-spinner fa-spin text-muted': this.form.isSubmitted,
                    'cursor-pointer' : !this.current,
                }
            }
        },

        created(){
            App.bus.$on('current-energy-code', (energyCode) => {
                this.current = (energyCode.id == this.energyCode.id)
            });
        }
    }
</script>
